module.exports = __webpack_public_path__ + "img/bly.481671d4.png";